import { useState } from "react";
import modalclose from "../images/modalclose.svg";
import userForm from "../images/userForm.svg";
import lock from "../images/lock.svg";
import eye from "../images/eye.svg";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLoginMutation } from "../store/apis";
import {
  closeLoginModal,
  loginFailure,
  loginSuccess,
  openRegisterModal,
  selectLoginModal,
  setLoginModal,
  setRegisterModal,
  setResetPasswordModal,
} from "../store/auth-slice";
import { API_URL } from "../constants";
import { handleApiError } from "../errors";
import PasswordReset from "./PasswordReset";

const Login = ({ isOpen, onClose }) => {
  const [passwordResetOpen, setPasswordResetOpen] = useState(false);
  const loginModalOpen = useSelector(selectLoginModal);
  const dispatch = useDispatch();
  const [login, { isLoading }] = useLoginMutation();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    phone: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    phone: "",
    password: "",
  });
  const navigate = useNavigate();

  if (!isOpen && !loginModalOpen) return null;

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      phone: "",
      password: "",
    };

    // Phone validation
    const phoneRegex = /^(7|9|1)\d{8}$/; // Starts with 7, 9, or 1 and must be exactly 9 digits

    if (!formData.phone) {
      newErrors.phone = "Phone number is required";
      isValid = false;
    } else if (!phoneRegex.test(formData.phone)) {
      newErrors.phone =
        "Invalid Ethiopian phone number (must start with 7, 9, or 1 and be 9 digits)";
      isValid = false;
    }

    // Password validation
    if (!formData.password) {
      newErrors.password = "Password is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
    // Clear error when user starts typing
    if (errors[id]) {
      setErrors((prev) => ({
        ...prev,
        [id]: "",
      }));
    }
  };
  // Update the Forgot Password link handler
  const openPasswordReset = (e) => {
    e.preventDefault();
    onClose(); // Close login modal
    setPasswordResetOpen(true); // Open password reset modal
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const response = await login({
        username: `251${formData.phone}`,
        password: formData.password,
      }).unwrap();

      const redirectUrl = sessionStorage.getItem("redirectUrl");
      if (redirectUrl) {
        sessionStorage.removeItem("redirectUrl");
        navigate(redirectUrl);
      }

      dispatch(
        loginSuccess({
          accessToken: response.accessToken,
          refreshToken: response.refreshToken,
          user: response.user,
        })
      );
      onClose();
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        general:
          error.data?.messafsfsfdfdfdfdffsdfge ||
          "Login failed. Please try again.",
      }));
      handleApiError(error, {
        setErrors,
        showToast: true,
        onAuthError: () => {
          // Handle authentication errors
        },
      });
    }
  };

  const openRegisterModalHandler = (e) => {
    e.preventDefault();
    dispatch(setRegisterModal(true));
    dispatch(setLoginModal(false));
  };
  const openResetPassModal = () => {
    dispatch(setResetPasswordModal(true));
    dispatch(setLoginModal(false));
  };

  return (
    <>
      {/* <PasswordReset
        isOpen={passwordResetOpen}
        onClose={() => setPasswordResetOpen(false)}
      /> */}

      <div
        className="fixed inset-0 bg-black/50 flex justify-center items-center z-50"
        role="dialog"
        aria-modal="true"
      >
        <div className="h-full w-full overflow-y-auto flex justify-center items-center">
          <div
            className="relative w-full max-w-[541px] animate-fade-in"
            tabIndex={0}
          >
            <div className="px-[15px]">
              <div className="bg-[#0C1B22] p-[32px_30px] rounded-[8px] relative overflow-auto border-l-2 border-t-2 border-r-2 border-b-2 border-[#33494E]">
                <div className="flex justify-between items-center pb-[10px] mb-5 border-b-[1px] border-[#33494E]">
                  <h4 className="text-white text-2xl font-medium">
                    LOGIN TO YOUR ACCOUNT
                  </h4>
                  <button
                    onClick={onClose}
                    className="w-[38px] h-[38px] min-w-[38px] flex justify-center items-center border-[1px] rounded-md border-[#33494E] bg-[rgba(0, 0, 0, 0.3)] hover:bg-[rgba(0, 0, 0, 0.5)] transition-all duration-[0.4s]"
                  >
                    <img src={modalclose} alt="close" />
                  </button>
                </div>
                <form onSubmit={handleSubmit} id="login">
                  {errors.general && (
                    <div className="mb-4 p-2 text-red-600 bg-red-100/20 rounded border border-red-600">
                      {errors.general}
                    </div>
                  )}

                  <div className="space-y-6">
                    {/* Phone Number Input */}
                    <div className="flex flex-col">
                      <label
                        htmlFor="phone"
                        className="text-base font-normal text-[#8DA0A9] mb-2"
                      >
                        Phone number*
                      </label>
                      <div className="relative flex">
                        <div className="bg-[#061015] border border-[#33494E] text-[#8DA0A9] h-[48px] px-4 flex items-center justify-center rounded-l-md">
                          +251
                        </div>
                        <input
                          type="text"
                          id="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          placeholder="7xxxxxxxx"
                          className="block w-full h-[48px] px-4 bg-[#061015] border border-[#33494E] rounded-r-md focus:outline-none focus:border-[#4A9BA5] text-base font-normal text-[#E9EDEF] placeholder:text-[#515D63]"
                        />
                      </div>
                      {errors.phone && (
                        <p className="mt-1 text-red-500 text-sm">
                          {errors.phone}
                        </p>
                      )}
                    </div>

                    {/* Password Input */}
                    <div className="flex flex-col">
                      <label
                        htmlFor="password"
                        className="text-base font-normal text-[#8DA0A9] mb-2"
                      >
                        Password*
                      </label>
                      <div className="relative">
                        <input
                          id="password"
                          type={showPassword ? "text" : "password"}
                          value={formData.password}
                          onChange={handleInputChange}
                          placeholder="Enter Password"
                          className="block w-full h-[48px] px-4 bg-[#061015] border border-[#33494E] rounded-md focus:outline-none focus:border-[#4A9BA5] text-base font-normal text-[#E9EDEF] placeholder:text-[#515D63]"
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          className="absolute top-1/2 -translate-y-1/2 right-[10px] w-[24px] h-[24px] flex items-center justify-center text-[#8DA0A9]"
                          tabIndex={-1}
                        >
                          <img
                            src={eye}
                            alt="toggle password visibility"
                            className="object-contain w-5"
                          />
                        </button>
                      </div>
                      {errors.password && (
                        <p className="mt-1 text-red-500 text-sm">
                          {errors.password}
                        </p>
                      )}
                    </div>

                    {/* Links */}
                    <div className="flex justify-between gap-[30px]">
                      <Link
                        to="#"
                        onClick={openResetPassModal}
                        className="text-[#4A9BA5] hover:text-[#6ABBC8] text-sm font-normal transition-all duration-300"
                      >
                        Forgot Password?
                      </Link>
                    </div>

                    {/* Terms agreement */}
                    {/* <div className="flex items-center gap-2">
                    <div className="relative flex items-center">
                      <input
                        type="checkbox"
                        id="rules"
                        className="w-6 h-6 rounded-sm"
                      />
                      <div className="absolute h-6 w-6 bg-[#061015] border border-[#33494E] rounded-sm"></div>
                    </div>
                    <label className="text-[#8DA0A9] text-sm">
                      By clicking button below, you agree to our{" "}
                      <Link to="/" className="text-[#4A9BA5]">
                        Terms & Conditions
                      </Link>
                    </label>
                  </div> */}

                    {/* Buttons */}
                    <div className="flex flex-col gap-4">
                      <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full bg-yellow hover:bg-[#3D8089] py-4 text-white font-medium rounded-md transition-all duration-300"
                      >
                        {isLoading ? "LOGIN IN..." : "LOGIN"}
                      </button>
                      <button
                        onClick={openRegisterModalHandler}
                        type="button"
                        className="w-full bg-buttonGradient bg-no-repeat text-white hover:text-white hover:border-[#1b4334] hover:bg-buttonGradientHover py-4 font-medium rounded-md transition-all duration-300"
                      >
                        REGISTER
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
